import { Directive, inject, Input, TemplateRef, ViewContainerRef, effect } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { ActionCode } from '../../core/constants/actions.constants';

@Directive({
  selector: '[appHasAction]',
  standalone: true
})
export class HasActionDirective {
  private readonly authService = inject(AuthService);
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  
  private currentAction: ActionCode | ActionCode[] | null = null;
  private hasViewCreated = false;

  @Input() set appHasAction(action: ActionCode | ActionCode[]) {
    this.currentAction = action;
    this.updateView();
  }

  constructor() {
    effect(() => {
      this.authService.actions();
      this.updateView();
    });
  }

  private updateView(): void {
    if (!this.currentAction) return;

    const hasPermission = this.checkPermission(this.currentAction);

    if (hasPermission && !this.hasViewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasViewCreated = true;
    } else if (!hasPermission && this.hasViewCreated) {
      this.viewContainer.clear();
      this.hasViewCreated = false;
    }
  }

  private checkPermission(action: ActionCode | ActionCode[]): boolean {
    if (Array.isArray(action)) {
      return action.some(a => this.authService.hasAction(a));
    } else {
      return this.authService.hasAction(action);
    }
  }
}
